import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export const NOT_FOUND_BRICK_IMG = "/UserFiles/images/brick-not-found.jpg";

interface ValueAtribute {
    name: string;
    label: string;
    value: string;
}

export type AttributeKeyTypeWithLabel = {
    style: ValueAtribute;
    color: ValueAtribute;
    manufacturer: ValueAtribute;
    locations: ValueAtribute;
    [key: string]: ValueAtribute;
};

export const getInitialAttributesWithLabel = () => {
    const initialAttributes = {
        manufacturer: { name: "", label: "", value: "" },
        style: { name: "", label: "", value: "" },
        locations: { name: "", label: "", value: "" },
        color: { name: "", label: "", value: "" },
    };

    return initialAttributes;
};

export const getAttributesWithLabelValue = (product: ProductModel | undefined) => {
    const attributeTypes = product?.attributeTypes;
    if (attributeTypes && attributeTypes?.length === 0) return getInitialAttributesWithLabel();
    let attr: AttributeKeyTypeWithLabel = getInitialAttributesWithLabel();
    if (attributeTypes?.length) {
        attributeTypes.map(item => {
            let value = "";
            if (item.attributeValues?.length) {
                value = item.attributeValues.reduce((acc, value) => {
                    if (!acc) {
                        return value.valueDisplay;
                    }
                    if (value.valueDisplay) {
                        return acc + ", " + value.valueDisplay;
                    }
                    return acc;
                }, "");
            }

            attr[item.name.toLowerCase()] = { name: item.name, label: item.label, value };
        });
    }
    attr.manufacturer = {
        name: "manufacturer",
        label: translate("Manufacturer"),
        value: product?.manufacturerItem ? product?.manufacturerItem : "",
    };

    return attr;
};
